// libs
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

// UI components
import Icon from '@material-ui/core/Icon';
import LoaderModal from '../components/LoaderModal.js';
import PasswordStrengthIndicator from '../components/PasswordStrengthIndicator';
import Navbar from '../components/Navbar.js';

// actions
import { mapDispatchToProps } from '../actions/Dispatcher';

// helpers
import capitalize from '../helpers/capitalize.js';
import validatePassword from '../helpers/validatePassword.js';

// styling
import '../css/home.css';

let Activate = ({
    getApplication,
    updateApplication,
    createUser,
    sendAlert,
}) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loadingModalIsOpen, setLoadingModalIsOpen] = useState(true);
    const [application, setApplication] = useState(null);
    const [invalidURL, setInvalidURL] = useState(false);

    useEffect(() => {
        const initData = async () => {
            const urlParams = Object.fromEntries(
                new URLSearchParams(window.location.search),
            );

            if (urlParams._id) {
                const application = await getApplication(`${urlParams._id}`);
                setApplication(application.data);
                setLoadingModalIsOpen(false);
            } else {
                setInvalidURL(true);
                setLoadingModalIsOpen(false);
            }
        };

        initData();
    }, []);

    async function activateAccount() {
        const validPassword = validatePassword(password);
        const validConfirmPassword = validatePassword(confirmPassword);
        if (!validPassword || !validConfirmPassword) {
            return window.alert('Password does not meet requirements');
        } else if (password !== confirmPassword) {
            return window.alert(
                "Password and confirm password fields don't match",
            );
        } else {
            setLoadingModalIsOpen(true);
            const vendorPassword = password;

            setTimeout(async () => {
                let newUser = {
                    user: {
                        type: application.role,
                        first_name: application.first_name,
                        last_name: application.last_name,
                        email: application.email,
                        phone_number: application.phone_number,
                        address: application.address,
                        city: application.city,
                        state: application.state,
                        zip_code: application.zip_code,
                        county: application.county,
                        geolocation: application.geolocation,
                        profile_image: application.profile_image,
                    },
                    password: vendorPassword,
                };

                if (application.unit) newUser.user.unit = application.unit;

                const data = await createUser(newUser);

                await updateApplication(application._id, {
                    applicationVendor: data.data.user._id,
                });

                const alert = {
                    channel: 'account-activation',
                    text: `*New Account Activated!* \nNAME\n${capitalize(
                        application.first_name,
                    )} ${capitalize(application.last_name)}\n\nROLE\n${
                        application.role
                    }\n\nCITY / STATE\n${application.city}, ${
                        application.state
                    }\n\nPROFILE IMAGE\n${application.profile_image}`,
                };

                await sendAlert(alert);
                setLoadingModalIsOpen(false);
                window.location.href = `${window.location.origin}/dashboard`;
            }, 1000);
        }
    }

    function renderInvalidURL() {
        return (
            <div className="p50">
                <p className="text-center">
                    Invalid URL, please contact support to continue.
                </p>
                <div className="flex flex-center">
                    <button
                        className="small btn3"
                        onClick={() => (window.location.pathname = '/')}
                    >
                        <div className="flex flex-center-y">
                            <span style={{ marginRight: 8 }}>Go Home</span>
                            <Icon>arrow_forward</Icon>
                        </div>
                    </button>
                </div>
            </div>
        );
    }

    function renderView() {
        return application ? (
            <div className="flex flex-center">
                <div className="mt25">
                    <h4 className="mb15">Activate Account</h4>
                    <div className="mb25">
                        <small>
                            Hello <b>{capitalize(application.first_name)}</b>,
                            please set a password for your account
                        </small>
                    </div>
                    <PasswordStrengthIndicator password={password} />
                    <label className="mt10">Password *</label>
                    <input
                        type="password"
                        name="password"
                        placeholder="******"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <label className="mt10">Confirm Password *</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="******"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <div className="mt10">
                        <button
                            className="purple small flex flex-center full-width"
                            onClick={() => activateAccount()}
                        >
                            <Icon>done</Icon>
                            <span style={{ marginLeft: 8 }}>
                                Save & Continue
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        ) : (
            <></>
        );
    }

    return (
        <div>
            {/* modals */}
            <LoaderModal isOpen={loadingModalIsOpen} />

            {/* main content */}
            <Navbar />
            {invalidURL ? (
                renderInvalidURL()
            ) : (
                <div className="pt75 pr25 pl25 pb15">{renderView()}</div>
            )}
        </div>
    );
};

Activate = connect(null, mapDispatchToProps)(Activate);

export default Activate;
